import service from '@/helpers/serviceGPAO'
// import { constantesId } from "@/helpers/constantes"

export function ajouterMenuStructure(structure) {
  preparerDonneeStructureMenu(structure)
  return service.post('menus/structure/ajouter', structure)
}
export function modifierMenuStructure(structure) {
  preparerDonneeStructureMenu(structure)
  return service.patch('menus/structure/modifier', structure)
}
export function obtenirMenuStructure(id, asBlob) {
  let url = 'menus/structure/'
  if ((typeof (id) == 'string') && id.startsWith('p')) {
    url += id.substr(1)
  } else {
    url += id;
  }
  if (asBlob) {
    return service.get(url, { responseType: 'blob' })
  }
  return service.get(url)
}

export function obtenirMenusJour(etablissementId) {
  return service.get("menus/menusdujour/" + etablissementId)
}
export function desactiverMenuStructure(id) {
  let url='menus/structure/desactiver/'
  if (typeof(id) == 'string' && id.startsWith('p')) {
    url += id.substr(1)
  } else {
    url += id
  }
  return service.patch(url)
}
export function supprimerMenuStructure(id) {
  let url='menus/structure/supprimer/'
  if ((typeof (id) == 'string') && id.startsWith('p')) {
    url+= id.substr(1)
  }
  else {
    url += id;
  }
  return service.delete(url )
}

export function chargerStructuresMenusDetaillees(etablissementId) {
  return service.get("menus/structure/listeDetaillee/" + etablissementId)
}
export function chargerToutesLesStructures(etablissementId) {
  return service.get("menus/structure/liste/" + etablissementId)
}
export function chargerTousLesMenus(etablissementId) {
  return service.get("menus/liste/" + etablissementId)
}
export function chargerMenuDateDebut(payload) {
  return service.get("menus/liste/" + payload.etablissementId + "/" + payload.apiDate)
}

export function chargerMenuDateDebutDateFin(payload) {
  return service.get("menus/liste/" + payload.etablissementId + "/" + payload.apiDateDebut + "/" + payload.apiDateFin)
}

export async function chargerMenuEtStructurePourDate(payload) {
  const url = "menus/liste/avecStructures/" + payload.etablissementId + "/" + payload.apiDate + "/" + payload.actifSeulement
  return service.get(url).then(response => {
    response.data.liste.forEach(x => {
      x.estStructure = !x.structId
      x.structureId= (x.estStructure)? x.id : x.structId
    })
    return response
  })
}

export function chargerStructures(etablissementId) {
  return service.get("menus/liste/structures/" + etablissementId)
}

export function chargerMenuStructuresAvecRecetteDeuxDates(payload) {
  return service.get("menus/structure/liste/" + payload.etablissementId + "/" + payload.apiDateDebut + "/" + payload.apiDateFin)
}
export function creerMenu(data) {
  return service.post('menus/creer', data)
}
export function obtenirMenu(id) {
  return service.get('menus/' + id)
}
export function supprimerMenu(id) {
  return service.delete('menus/supprimer/' + id)
}
export function modifierMenu(data) {
  return service.patch('menus/modifier', data)
}
export function dupliquerMenu(etablissementId, parametres) {
  return service.post('menus/dupliquer/' + etablissementId, parametres)
}
export function validerMenu(menuId) {
  return service.patch('menus/valider/' + menuId)
}
export function devaliderMenu(menuId) {
  return service.patch('menus/devalider/' + menuId)
}

export function getLieuxConsommation(etablissementId) {
  return service.get('menus/lieuConsommation/liste/' + etablissementId)
}
export function getLieuConsommation(lieuConsommationId) {
  return service.get('menus/lieuConsommation/' + lieuConsommationId)
}
export function changerStatutActifLieuConsommation(lieuConsommationId) {
  return service.patch('menus/lieuConsommation/changerStatutActif/' + lieuConsommationId)
}
export function supprimerLieuConsommation(lieuConsommationId) {
  return service.delete('menus/lieuConsommation/supprimer/' + lieuConsommationId)
}

// pour : format AAAAMMJJ
export function appliquerEffectifPortage(etabId, tabPour) {
  return service.patch("menus/appliquerEffectif/" + etabId ,tabPour)
}

function preparerDonneeStructureMenu(structure) {
  structure.services.forEach(service => {
    if (!service.effectif) {
      service.effectif = 0
    }
    if (service.planComposantes) {
      service.planComposantes.forEach(composante => {
        if (!composante.effectif) {
          composante.effectif = 0
        }
        if (composante && composante.id < 0) {
          composante.id = 0;
        }
        if (structure.gestionParPlan) {
          composante.regimeId = structure.regimeId
          composante.textureId = structure.textureId
        }
      })
    }
  })
  if (!structure.gestionParPlan) {
    structure.regimeId = undefined
    structure.textureId = undefined
  }
}